import { Component, OnInit } from '@angular/core';
import { getParamFromRoute } from 'src/app/_helpers/extensions.module';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/_services/breadcrumbs.service';

// core components
@Component({
  selector: 'client-messages',
  templateUrl: 'client-messages.component.html',
  styleUrls: ['client-messages.component.scss'],
})
export class ClientMessagesComponent implements OnInit {

  initialized: boolean;
  clientUserId: number;

  constructor(private route: ActivatedRoute, private breadcrumbs: BreadcrumbsService, private router: Router) {}

  ngOnInit() {
    this.clientUserId = parseInt(getParamFromRoute(this.route, 'id'));
    this.breadcrumbs.SetBreadcrumb('Messages', this.router.url, []);
    this.initialized = true;
  }
}
